/*
 * Project: Dynamedics Portal Web
 * Created Date: Thursday December 21st 2023
 * Author: KasunKarunasekara
 * -----
 * Last Modified: Thursday December 21st 2023 3:48:11 pm
 * Modified By: KasunKarunasekara at <kkarunasekara@mitrai.com>
 * -----
 * Copyright (c) 2023 Mitra Sparks
 * -----
 * HISTORY:
 */

import { Tooltip, Typography } from '@material-ui/core';
import React from 'react';
import styled from 'styled-components';

const CustomSwitchSelectorWrapper = styled.div`
  display: flex;
  background-color: #00b1aa;
  padding: 3px;
  border-radius: 12px;
`;

const CustomSwitchOption = styled.div`
  flex: 1;
  text-align: center;
  margin-right: 1px;
  margin-left: 1px;
  color: ${(props) =>
    props.isSelected ? props.selectedFontColor : props.fontColor};
  background-color: ${(props) =>
    props.isSelected ? props.selectedBackgroundColor : props.backgroundColor};
  padding: 4px;
  min-width: 45px;
  cursor: pointer;
  border-radius: 12px;
  margin-x: 2px;
  &:hover {
    background-color: ${(props) =>
      props.isSelected ? props.selectedBackgroundColor : '#007A70'};
    /* Add hover styles as needed */
  }
`;

export default function CustomSwitchSelector({
  options,
  onChange,
  value,
  initialSelectedIndex,
  selectedBackgroundColor,
  selectedFontColor,
  fontColor,
  backgroundColor
}) {
  const handleOptionClick = (index) => {
    onChange(options[index].value);
  };

  return (
    <CustomSwitchSelectorWrapper>
      {options.map((option, index) => (
        <Tooltip title={option.tooltip}>
          <CustomSwitchOption
            key={index}
            isSelected={value === option.value}
            selectedBackgroundColor={selectedBackgroundColor}
            selectedFontColor={selectedFontColor}
            fontColor={fontColor}
            backgroundColor={backgroundColor}
            onClick={() => handleOptionClick(index)}
          >
            <Typography variant="subtitle2" sx={{ fontSize: 13 }}>
              {option.label}
            </Typography>
          </CustomSwitchOption>
        </Tooltip>
      ))}
    </CustomSwitchSelectorWrapper>
  );
}
